import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ColorPickerDirective } from 'ngx-color-picker';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

interface ColorDialogData {
  initialColor: string
  title?: string
}

@Component({
  selector: 'pixl-color-picker-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ColorPickerDirective,
    MatDividerModule,
    TranslocoModule
  ],
  templateUrl: './color-picker-dialog.component.html',
  styleUrls: ['./color-picker-dialog.component.scss']
})
export class ColorPickerDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ColorPickerDialogComponent>);
  private readonly dialogData = inject<ColorDialogData>(MAT_DIALOG_DATA);
  private translocoService = inject(TranslocoService);

  public color = signal<string>(this.dialogData?.initialColor || '#000');
  public dialogTitle = computed(() => {
    const prefix = this.dialogData?.title || this.translocoService.translate('color');
    return this.translocoService.translate('select_color_title', { name: prefix });
  });

  constructor() {
    const finalColor = this.dialogData?.initialColor || '#000';
    this.color.set(finalColor);
  }

  protected onColorChange(newColor: string): void {
    this.color.set(newColor);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected onConfirm(): void {
    this.dialogRef.close(this.color());
  }
}
